module.exports = __webpack_public_path__ + "assets/img/sinocare.b2b35844.png";